module.exports = __webpack_public_path__ + "static/media/DC_F_Jacquard_Palestro_DK Grey_Bordeaux.e4d1d039.png";